<div class="growls" aria-live="polite" aria-relevant="additions" aria-label="Updates">
  @for (message of growls.messages(); track message.id) {
    <div class="growl" animate.enter="growl-enter" animate.leave="growl-leave" [attr.data-tone]="message.tone" (mouseenter)="growls.pause(message.id)"
      (mouseleave)="growls.resume(message.id)" (focusin)="growls.pause(message.id)" (focusout)="growls.resume(message.id)">
      <app-icon [name]="message.tone === 'success' ? 'check' : 'info'" />
      <div class="growl-content">
        <p>{{ message.text }}</p>
        @if (message.action; as action) {
          <a appButton="quiet" [routerLink]="action.route" (click)="growls.dismiss(message.id)">{{ action.label }}</a>
        }
      </div>
      <button type="button" appButton="quiet" aria-label="Dismiss update" (click)="growls.dismiss(message.id)"><app-icon name="close" /></button>
    </div>
  }
</div>
